import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import DataObjectIcon from '@mui/icons-material/DataObject';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PersonIcon from '@mui/icons-material/Person';
import GridOnIcon from '@mui/icons-material/GridOn';
import SettingsIcon from '@mui/icons-material/Settings';
import ListIcon from '@mui/icons-material/List';
import SubjectIcon from '@mui/icons-material/Subject';
import AssignmentIcon from '@mui/icons-material/Assignment';
import MediationIcon from '@mui/icons-material/Mediation';
import FullScreenIcon from '@mui/icons-material/Fullscreen';
import FullScreenExitIcon from '@mui/icons-material/FullscreenExit';
import SyncIcon from '@mui/icons-material/Sync';
import WarningIcon from '@mui/icons-material/Warning';

const IconMap = {
  BidHeader: AssignmentIcon,
  BidLine: MediationIcon,
  Context: SubjectIcon,
  Custom: GridOnIcon,
  EndUser: PersonIcon,
  List: ListIcon,
  Reseller: StorefrontIcon,
  Settings: SettingsIcon,
};

export {
  AssignmentIcon,
  DataObjectIcon,
  FormatListBulletedIcon,
  FullScreenIcon,
  FullScreenExitIcon,
  GridOnIcon,
  IconMap,
  ListIcon,
  MediationIcon,
  QuestionMarkIcon,
  PersonIcon,
  SettingsIcon,
  StorefrontIcon,
  SubjectIcon,
  SyncIcon,
  WarningIcon,
};
